<template>
  <div v-click-outside="close">
    <slot>
      <slot name="label" v-bind="{ toggle, isOpen }" />
      <div class="overflow-y-hidden">
        <SlideInFromTopTransition delay-in="delay-200">
          <slot v-if="!isOpen" name="collapsed" />
        </SlideInFromTopTransition>
        <SlideInFromTopTransition delay-in="delay-200">
          <slot
            v-if="isOpen"
            name="collapse-content"
            v-bind="{ toggle, close }"
          />
        </SlideInFromTopTransition>
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import ClickOutside from 'vue-click-outside'
import SlideInFromTopTransition from '#layers/base/components/ui/transitions/SlideInFromTopTransition.vue'

export default defineComponent({
  name: 'Collapse',
  components: {
    SlideInFromTopTransition,
  },
  directives: {
    ClickOutside,
  },
  setup() {
    const isOpen = ref(false)

    return {
      isOpen,
      close: () => (isOpen.value = false),
      toggle: () => (isOpen.value = !isOpen.value),
    }
  },
})
</script>
